// src/hooks/useUsuarios.js
import { useState, useEffect, useCallback } from "react";
import apiService from "../services/api.service";

export const useUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsuarios = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await apiService.getAllUsers();
      setUsuarios(data);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching usuarios:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsuarios();
  }, [fetchUsuarios]);

  const updateRole = async (userId, newRole) => {
    const previousUsuarios = [...usuarios];
    
    // Optimistic update
    setUsuarios(prev => 
      prev.map(u => u.uid === userId ? { ...u, role: newRole } : u)
    );
    
    try {
      await apiService.updateUserRole(userId, newRole);
    } catch (err) {
      // Revert on error
      setUsuarios(previousUsuarios);
      throw err;
    }
  };

  const toggleStatus = async (userId, currentStatus) => {
    try {
      if (currentStatus) {
        // Si está activo, desactivar
        await apiService.deactivateUser(userId);
      } else {
        // Si está inactivo, activar
        await apiService.activateUser(userId);
      }
      
      // Actualizar el estado local
      setUsuarios(prev => 
        prev.map(u => u.uid === userId ? { ...u, activo: !currentStatus } : u)
      );
    } catch (err) {
      throw err;
    }
  };

  return {
    usuarios,
    loading,
    error,
    fetchUsuarios,
    updateRole,
    toggleStatus
  };
};